import { API } from '@ananasbear/superapi'

const api= new API()

export default api
